import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

export const setAddToCartError = (history, location, addToCartError) => {
  history.replace({
    ...location,
    state: {
      ...location.state,
      addToCartError: addToCartError,
    },
  });
};

const useAddToCartError = () => {
  const location = useLocation();
  const history = useHistory();
  const [addToCartError] = useState(location?.state?.addToCartError);
  const [shouldRemoveErrorFromLocation, setShouldRemoveErrorFromLocation] =
    useState(location?.state?.addToCartError?.length > 0);

  useEffect(() => {
    if (shouldRemoveErrorFromLocation) {
      setShouldRemoveErrorFromLocation(false);
      history.replace({
        ...location,
        state: {
          ...location.state,
          addToCartError: undefined,
        },
      });
    }
  }, [shouldRemoveErrorFromLocation, history, location]);

  return addToCartError;
};

export default useAddToCartError;
